window.addEventListener('load', function () {

    let list = document.querySelectorAll('.solutions-for-industry-list__item');

    if (list.length) {
        list[0].classList.add('active');
        document.addEventListener('click', function (e) {

            const solutionsElement = e.target.closest('.solutions-for-industry-list__heading');

            if (!solutionsElement) return true;

            const isClosed = !solutionsElement.closest('.solutions-for-industry-list__item').classList.contains('active');
            const solutionsElements = document.querySelectorAll('.solutions-for-industry-list__item');

            for (let i = 0, n = solutionsElements.length; i < n; i++) {
                if (!isClosed) {
                    if (document.documentElement.clientWidth < 1024) {
                        solutionsElements[i].classList.remove('active');
                    }
                    else {
                        continue;
                    }
                }
                else {
                    solutionsElements[i].classList.remove('active');
                }
            }

            if (isClosed) solutionsElement.closest('.solutions-for-industry-list__item').classList.add('active');
        });
    }

});